'use strict';

module.exports = require('openchemlib-extended/lib/extend')(require('openchemlib/minimal'));



// WEBPACK FOOTER //
// ./node_modules/openchemlib-extended-minimal/index.js